module.exports = __webpack_public_path__ + "img/1J7.5b34113c.png";